import { createAction, props } from '@ngrx/store';
import { PromptTypes } from 'generated/graphql-types';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { VoiceMailGreetingPromptOption } from '../../mailbox-details/models/voicemail-greeting-prompt-option.model';
import { FileOption } from '../../prompt-details/models/file.option.interface';
import { PromptDetailSaveEvent } from '../../prompt-details/models/prompt-detail-form-submit-event';
import { GetPromptDetail_prompt } from '../../prompt-details/queries/generated/GetPromptDetail';
import { SavePrompt } from '../../prompt-details/queries/generated/SavePrompt';
import { PromptOption } from '../../prompt-register/models/prompt-option.interface';
import { RecordedAudioOutput } from '../models/recorded-prompt';
import { FileSaveModel } from '../models/save-file-only-models';

export const addPrompt = createAction('[Add Prompt] Add Prompt');

export const createPrompt = createAction('[Create Prompt] Create Prompt', props<PromptDetailSaveEvent>());

export const createPromptAndAddAnother = createAction(
   '[Create Prompt] Create Prompt and Add Another',
   props<PromptDetailSaveEvent>()
);

export const saveFileOnly = createAction('[API] Save File Only', props<{ fileModelToSave: FileSaveModel }>());

export const recordPrompt = createAction(
   '[Record Prompt] Record Prompt',
   props<{
      prompt: PromptDetailSaveEvent;
      routeToExtension: string;
      destinationNumber: string;
      isContinuous: boolean;
   }>()
);

export const recordPromptFileOnly = createAction(
   '[Record Prompt] Record Prompt File Only',
   props<{
      routeToExtension: string;
      destinationNumber: string;
      promptId: number;
      name: string;
      promptType: PromptTypes;
   }>()
);

export const setRecordingFromExtensionVariables = createAction(
   '[Record Prompt] New From Extension Prompt',
   props<{
      creatingNewFromExtension: boolean;
      recordingNewFromAdd: boolean;
      voiceMailGreetingPrompt: VoiceMailGreetingPromptOption | null;
   }>()
);

export const recordNewPromptNotification = createAction(
   '[API] Create New From Extension Prompt Success',
   props<{ promptId: number }>()
);
export const recordNewFromExtensionPromptSuccess = createAction(
   '[Record Prompt] Record New From Extension Prompt Success',
   props<{ data: GetPromptDetail_prompt; voiceMailGreetingPrompt: VoiceMailGreetingPromptOption | null }>()
);

export const createNewFromExtensionPrompt = createAction(
   '[Create Prompt] New From Extension Prompt',
   props<PromptDetailSaveEvent>()
);

export const createPromptSuccess = createAction(
   '[API] Create Prompt Success',
   props<{ promptId: number; promptName: string | null }>()
);

export const createPromptAndAddAnotherSuccess = createAction(
   '[API] Create Prompt and Add Another Success',
   props<{ promptId: number; promptName: string | null }>()
);

export const createPromptSuccessNoRouteToDetail = createAction(
   '[API] Create Prompt Success No Detail Route',
   props<{ promptItem: PromptOption }>()
);

export const createFileSuccess = createAction('[API] Create File Success', props<{ fileItem: FileOption | null }>());

export const createFileFromCallToRecordSuccess = createAction(
   '[API] Create File From Call To Record Success',
   props<{ prompt: PromptOption }>()
);

export const createFileFailure = createAction('[API] Create File Failure', props<SingleGraphError>());

export const recordPromptCancelPressed = createAction('[API] Record Prompt Cancel');

export const recordPromptRequestSend = createAction(
   '[API] Record Prompt Request Send',
   props<{ promptRecordingCallDetailId: number; promptRecordingCallSessionId: string }>()
);

export const createNewFromExtensionPromptSuccess = createAction(
   '[API] Create New From Extension Prompt Success',
   props<{ prompt: SavePrompt; voiceMailGreetingPrompt: VoiceMailGreetingPromptOption | null }>()
);

export const createPromptFailure = createAction('[API] Create Prompt Failure', props<SingleGraphError>());

export const recordPromptFromMicrophone = createAction('[Record Prompt From Mic] Record Prompt');

export const stopMicrophoneRecording = createAction(
   '[Record Prompt] Stop Recording',
   props<{ file: RecordedAudioOutput | null }>()
);

export const clearMicrophoneRecording = createAction('[Clear Recorded Prompt] Clear recorded Prompt');
